@if (isOpen) {
<div class="glossary-modal" role="presentation" (click)="onOverlayClick()">
  <div #panel class="glossary-modal__panel" role="dialog" aria-modal="true" aria-labelledby="glossary-modal-title"
    (click)="onPanelClick($event)">
    <header class="glossary-modal__header">
      <h2 id="glossary-modal-title" class="glossary-modal__title">用語解説</h2>
      <button #closeButton type="button" class="glossary-modal__close" aria-label="閉じる" (click)="onCloseClick()">
        <img class="glossary-modal__close-icon" ngSrc="/assets/close.svg" alt="" width="24" height="24" />
      </button>
    </header>

    <div class="glossary-modal__scroll-area">
      <div #scrollContent class="glossary-modal__scroll-content" (scroll)="onScroll()">
        <div class="glossary-modal__terms">
          @for (term of terms(); track term.wordId) {
          <app-glossary-term-row [term]="term"></app-glossary-term-row>
          }
        </div>
      </div>

      @if (showScrollbar) {
      <div class="glossary-modal__scrollbar" aria-hidden="true">
        <div class="glossary-modal__scrollbar-track">
          <div class="glossary-modal__scrollbar-thumb" [style.height.px]="thumbHeight"
            [style.transform]="'translateY(' + thumbOffset + 'px)'"></div>
        </div>
      </div>
      }
    </div>
    <app-copy-right />
  </div>
</div>
}